import React from 'react';
import { IAgentLandingZipCodeData } from 'types/agent-landing-page';

import { makeStyles } from '@material-ui/core/styles';

import DigitalAdZipCodeDataDisplay from './DigitalAdZipCodeDataDisplay';
import DigitalAdZipCodeForm from './DigitalAdZipCodeForm';

const useStyles = makeStyles((theme) => ({

}));

type Props = {
  agentLandingPageToken: string;
  agentData: any;
};

const DigitalAd = ({ agentLandingPageToken, agentData }: Props) => {
  const classes = useStyles();

  const [zipCodeData, setZipCodeData] = React.useState<IAgentLandingZipCodeData | undefined>();

  if (!zipCodeData) {
    return (
      <DigitalAdZipCodeForm
        agentLandingPageToken={agentLandingPageToken}
        setZipCodeData={setZipCodeData}
      />
    );
  }

  return (
    <DigitalAdZipCodeDataDisplay
      agentLandingPageToken={agentLandingPageToken}
      zipCodeData={zipCodeData!}
    />
  );
};

export default DigitalAd;
